import { DrawingTool } from "../../../../types/Enum";
import { EnumEventBus, eventBus } from "../../../EventBus";


export function genHandleFuncs(toolName: DrawingTool, setSelectedTool: (tool: DrawingTool) => void) {
  const onHandleFunc = () => genHandleFunc(toolName, undefined, (toolName) => setSelectedTool(toolName));
  const onHandleSecondFunc = () => {
    if (toolName == DrawingTool.clear || toolName == DrawingTool.returnBack) genHandleFunc(toolName, undefined, (toolName) => setSelectedTool(toolName));
    else if (toolName == DrawingTool.ruler || toolName == DrawingTool.protractor || toolName == DrawingTool.compass) genHandleFunc(toolName, true, (toolName) => setSelectedTool(toolName))
    else genHandleFunc(DrawingTool.empty, undefined, (toolName) => setSelectedTool(toolName));
  }
  return { onHandleFunc, onHandleSecondFunc };
}

function genHandleFunc(tool: DrawingTool, isSecond: boolean = false, setSelectedTool: (tool: DrawingTool) => void) {
  if (tool == DrawingTool.clear) eventBus.emit(EnumEventBus.clearAll);
  else if (tool == DrawingTool.returnBack) eventBus.emit(EnumEventBus.delLastDrawing);
  else {
    const color = tool.includes("RED") ? 0xff0000 : tool.includes("BLUE") ? 0x0000FF : undefined;
    setSelectedTool(tool);
    eventBus.emit(EnumEventBus.setSelectedTool, tool, color);
    if (tool == DrawingTool.ruler) eventBus.emit(EnumEventBus.showRuler, !isSecond);
    if (tool == DrawingTool.protractor) eventBus.emit(EnumEventBus.showProtractor, !isSecond);
    if (tool == DrawingTool.compass) eventBus.emit(EnumEventBus.showCompass, !isSecond);
  };
};